module.exports = __webpack_public_path__ + "img/hp-logo.7736db6b.svg";